export default (httpClient) => ({
  save: async ({ name, email, password, status, admin, colaborador_id, token }) => {
  const headers = {
    Authorization: "Bearer " + token,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  const response = await httpClient.post(
    "/users",
    {
      name,
      email,
      password,
      status,
      admin,
      colaborador_id,
    },
    { headers }
  );
  return { data: response.data };
},

update: async ({ id, name, email, password, status, admin, colaborador_id, token }) => {
  const headers = {
    Authorization: "Bearer " + token,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  const response = await httpClient.patch(
    "/users/" + id,
    {
      id,
      name,
      email,
      password,
      status,
      admin,
      colaborador_id,
    },
    { headers }
  );
  return { data: response.data };
},


  getById: async ({ id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/users/" + id, { headers });
    return {
      data: response.data,
    };
  },

  getAll: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/users", { headers });
    return { data: response.data };
  },

  delete: async ({ id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.delete("/users/" + id, { headers });
    return {
      data: response,
    };
  },

  info: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/infos-sistema", { headers });
    return { data: response.data };
  },

  infoPedidos: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pedidos-pendentes", { headers });
    return { data: response.data };
  },
});
